import { NgModule } from '@angular/core';

import { NtpDateTimeSettingsApiService } from '../api';

import { SysApiNtpDateTimeApiService } from './sys-api-ntp-date-time-api.service';

@NgModule({
	providers: [
		SysApiNtpDateTimeApiService,
		{
			provide: NtpDateTimeSettingsApiService,
			useClass: SysApiNtpDateTimeApiService
		}
	]
})
export class SysApiNtpDateTimeDataAccessModule {}
